export const ACTIONS = {
    SET_SELECTED_ROWS: 'RESPONSES_TABLE/SET_SELECTED_ROWS',
    RESET_SELECTED_ROWS: 'RESPONSES_TABLE/RESET_SELECTED_ROWS',
    ADD_SELECTED_ROWS: 'RESPONSES_TABLE/ADD_SELECTED_ROWS',
    REMOVE_SELECTED_ROWS: 'RESPONSES_TABLE/REMOVE_SELECTED_ROWS',
};

export const ROWS = 'ROWS';
export const SELECTED_ROWS = 'SELECTED_ROWS';
